import { render, staticRenderFns } from "./projectRevokeDialog.vue?vue&type=template&id=2a50eeec&scoped=true"
import script from "./projectRevokeDialog.vue?vue&type=script&lang=js"
export * from "./projectRevokeDialog.vue?vue&type=script&lang=js"
import style0 from "./projectRevokeDialog.vue?vue&type=style&index=0&id=2a50eeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50eeec",
  null
  
)

export default component.exports